// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"91c9b134","337":"cca65775","647":"cdc4cec6","946":"8a7226c1"}[chunkId] + ".chunk.css";
};